import { useAdminCompanies } from "../../api/admin";
import { Building2, Monitor, Users, Activity } from "lucide-react";

function StatCard({ icon, label, value, color }: { icon: React.ReactNode; label: string; value: number; color: string }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white dark:border-riot-navy-700 dark:bg-riot-navy-800 p-5">
      <div className="mb-2 flex items-center gap-2">
        <div className={`flex h-8 w-8 items-center justify-center rounded-lg ${color}`}>{icon}</div>
        <span className="text-sm text-gray-500 dark:text-riot-navy-300">{label}</span>
      </div>
      <p className="text-3xl font-bold text-gray-900 dark:text-white">{value}</p>
    </div>
  );
}

export function AdminDashboardPage() {
  const { data } = useAdminCompanies();
  const companies = data?.data ?? [];
  const activeCompanies = companies.filter((c) => c.status === "active").length;
  const totalDevices = companies.reduce((sum, c) => sum + (c.maxDevices || 0), 0);

  return (
    <div>
      <h1 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">Platform Admin Dashboard</h1>

      <div className="mb-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
        <StatCard icon={<Building2 size={16} className="text-riot-gold-500" />} label="Total Companies" value={companies.length} color="bg-riot-gold-50 dark:bg-riot-gold-500/10" />
        <StatCard icon={<Building2 size={16} className="text-green-600 dark:text-green-400" />} label="Active Companies" value={activeCompanies} color="bg-green-50 dark:bg-green-500/10" />
        <StatCard icon={<Monitor size={16} className="text-purple-600 dark:text-purple-400" />} label="Total Device Capacity" value={totalDevices} color="bg-purple-50 dark:bg-purple-500/10" />
        <StatCard icon={<Users size={16} className="text-amber-600 dark:text-amber-400" />} label="Total User Capacity" value={companies.reduce((s, c) => s + (c.maxUsers || 0), 0)} color="bg-amber-50 dark:bg-amber-500/10" />
      </div>

      <div className="rounded-lg border border-gray-200 bg-white dark:border-riot-navy-700 dark:bg-riot-navy-800 p-5">
        <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-gray-900 dark:text-white">
          <Activity size={16} className="text-gray-400 dark:text-riot-navy-400" /> System Health
        </h3>
        <div className="grid grid-cols-3 gap-4 text-sm">
          <div className="rounded-md bg-green-50 p-3 text-center dark:bg-green-950/30">
            <p className="text-lg font-bold text-green-700 dark:text-green-300">Healthy</p>
            <p className="text-xs text-green-600 dark:text-green-400">API Gateway</p>
          </div>
          <div className="rounded-md bg-green-50 p-3 text-center dark:bg-green-950/30">
            <p className="text-lg font-bold text-green-700 dark:text-green-300">Healthy</p>
            <p className="text-xs text-green-600 dark:text-green-400">DynamoDB</p>
          </div>
          <div className="rounded-md bg-green-50 p-3 text-center dark:bg-green-950/30">
            <p className="text-lg font-bold text-green-700 dark:text-green-300">Healthy</p>
            <p className="text-xs text-green-600 dark:text-green-400">IoT Core</p>
          </div>
        </div>
      </div>
    </div>
  );
}
